import PropTypes from "prop-types";
import { format, parseISO } from "date-fns";
import TextButton from "@shared/v2/TextButton";
import { TD, TR } from "../../../Reports/components/BusinessDashboard/Table/Table";
import { ROW_BORDER } from "./ActivityHistoryRow";
import openLeadIndexFromTagName from "../../../Reports/components/OpenHouseDashboard/helpers/openLeadIndexFromTagName";

const OpenHouseHistoryRow = ({
  activity: { address, startDate, startTime, endTime, hostName, attendees, leads, uuid },
}) => (
  <TR key={uuid}>
    <TD className={ROW_BORDER}>
      <div>{address.streetAddress}</div>
      <div>
        {address.city}, {address.state} {address.postalCode}
      </div>
    </TD>
    <TD className={ROW_BORDER}>
      <div>{format(parseISO(startDate), "E. MM/dd/yyyy")}</div>
      <div>
        {startTime} - {endTime}
      </div>
    </TD>
    <TD className={ROW_BORDER}>{hostName}</TD>
    <TD className={ROW_BORDER}>{attendees}</TD>
    <TD className={ROW_BORDER}>
      {leads > 0 ? (
        <TextButton
          size="medium"
          className="tw-p-0"
          onClick={openLeadIndexFromTagName(address.streetAddress)}
        >
          {leads}
        </TextButton>
      ) : (
        leads
      )}
    </TD>
  </TR>
);

OpenHouseHistoryRow.propTypes = {
  activity: PropTypes.shape({
    address: PropTypes.shape({
      streetAddress: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
    }).isRequired,
    startDate: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    hostName: PropTypes.string.isRequired,
    attendees: PropTypes.number.isRequired,
    leads: PropTypes.number.isRequired,
    uuid: PropTypes.string.isRequired,
  }).isRequired,
};

export default OpenHouseHistoryRow;
